'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LogentryModel = function () {
  function LogentryModel(data) {
    _classCallCheck(this, LogentryModel);

    this.target = null;

    this.values = {
      id: null,
      object_type_id: null,
      target_id: null,
      description: null,
      timestamp: null
    };

    window.PRIM.modelMapper.mapToModel(data, this.values);
  }

  _createClass(LogentryModel, [{
    key: 'getTitle',
    value: function getTitle() {
      return [this.values.timestamp ? window.PRIM.getUtcTimestamp(new Date(this.values.timestamp)).toISOString().substring(0, 19).replace('T', ' ') : null].join(' ');
    }
  }, {
    key: 'getSubtitle',
    value: function getSubtitle() {
      return [this.values.description].join(' ');
    }
  }, {
    key: 'getImage',
    value: function getImage() {
      if (this.target && this.target.getImage) {
        return this.target.getImage();
      } else {
        return null;
      }
    }
  }, {
    key: 'getIndex',
    value: function getIndex() {
      if (this.getCompareString()) {
        return this.getCompareString().substring(0, 4).toUpperCase();
      }

      return null;
    }
  }, {
    key: 'getCompareString',
    value: function getCompareString() {
      var title = [];

      if (this.values.timestamp) {
        title.push(this.values.timestamp ? window.PRIM.getUtcTimestamp(new Date(this.values.timestamp)).toISOString().substring(0, 19).replace('T', ' ') : null);
      }

      if (this.values.description) {
        title.push(this.values.description);
      }

      return title.join(' ');
    }
  }, {
    key: 'getJSON',
    value: function getJSON() {
      var result = {};

      window.PRIM.modelMapper.mapToObject(this.values, result);

      return result;
    }
  }]);

  return LogentryModel;
}();

exports.default = LogentryModel;


//////////////////
// WEBPACK FOOTER
// ./js/modules/logentry/model/LogentryModel.js
// module id = 11
// module chunks = 0